import ProjectDetailContainer from "./ProjectDetailContainer";
export default ProjectDetailContainer;
